/* Variables */
const style = document.createElement('style');
const img1 = require("url:../assets/lab1.webp")
const img2 = require("url:../assets/lab2.webp")

/* Class Laboratorio */
export class LaboratorioPage extends HTMLElement {

    connectedCallback() {
        this.render();
    }

    render() {
        this.className = 'laboratorio-page';
        this.innerHTML =
        `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo laboratorio__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">Laboratorio de Análisis Clínicos y Microbiológicos</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">La Dirección del Laboratorio tiene como objetivo la calidad, innovación tecnológica y la mejora continua, poniendo énfasis en la satisfacción y seguridad de nuestros pacientes y médicos; mediante la entrega de resultados confiables y reproducibles, con un tiempo de respuesta adecuado a los compromisos establecidos y de acuerdo al uso previsto para diagnóstico, pronóstico y seguimiento clínico.<br>El plantel del Laboratorio cuenta con destacados profesionales comprometidos con la capacitación continua.<br>En el mes de enero de 2023, el Laboratorio obtuvo su acreditación del programa de evaluación externa de calidad de la fundación bioquímica argentina.<br>Cumplir con esta evaluación vigente implica que el Laboratorio tiene implementado un sistema de Gestión de la Calidad en mejora continua, reconociendo su competencia técnica para la realización de los análisis acreditados.<br><br>• Dirección Técnica:<br>Dra. Liliana Bertola - M.P. 3.585<br><br>• Bioquimicos:<br>Dra. Gisel Bersi - M.P. 6.343<br>Dra. María Julia Armonti - M.P. 4.767<br>Dra. Flavia Máspero - M.P. 6.656<br><br>• Tec. Laboratorio:<br>Avila Daniela<br>Emiliozzi Liliana<br>Ortiz Karina</h5>
                            <h5 class="body__cuerpo-text-subtitle">• Contacto:</h5>
                            <div class="service-actions">
                                <a class="service-btn" href="/horarios">Horarios</a>
                                <a class="service-btn" href="https://api.whatsapp.com/send?phone=543585610243&text&source&data&app_absent&lang=es">WhatsApp</a>
                                <a class="service-btn" href="mailto:laboratorio@sanatorioprivado.com.ar">Email</a>
                            </div>
                        </div>
                        <div class="body__cuerpo-text">
                            <h5 class="body__cuerpo-text-subtitle">Preparación para Estudios</h5>
                            <div class="body__cuerpo-box">
                                <a class="link" href="#">Curva de Glucosa</a>
                                <a class="link" href="#">Recolección de orina de 24Hs para dosar calciura</a>
                                <a class="link" href="#">Extracción de Serotonina</a>
                                <a class="link" href="#">Clearence de Creatinina</a>
                                <a class="link" href="#">Examen Coparasitologico</a>
                                <a class="link" href="#">Cortisol Salival</a>
                                <a class="link" href="#">Extracción de Prolactina</a>
                            </div>
                            <div class="body__cuerpo-box">
                                <img src="${img1}" class="body__cuerpo-fotos" alt="Laboratorio de análisis" loading="lazy">
                                <img src="${img2}" class="body__cuerpo-fotos" alt="Laboratorio de análisis" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
        style.innerHTML =
        `
        .laboratorio__cuerpo{
            flex-direction: column;
        }
        `
        this.appendChild(style)
    }
}

/* Define */
customElements.define("laboratorio-page", LaboratorioPage)
